import { useState } from "react";
import { useTranslation } from "react-i18next";
import { PageLayout } from "../../Components/PageLayout";
import { usePaginatedQuery } from "../../Hooks/usePaginatedQuery";
import { buildURLWithParams } from "../../Components/Utility/URLUtils";
import { convertToPST } from "../../Helper/FormatDatetimes";
import DataTable from "../../Components/DataTable/DataTable";
import DateRange from "../../Components/DataTable/Filters/DateRange";
import { TableNavigation } from "../../Components/Tables/Vehicles/TableNavigation";
import CreateReceipt from "./Modals/CreateReceipt";
import { useNavigate } from "react-router-dom";
import { Button } from "../../Components/ui/button";
import { InputFilter } from "../../Components/ui/table/filters/input";

const DEFAULT_URL = "/safety/receipts/";

const receiptsColumns = (t) => [
  {
    key: "status",
    header: t("yard-tables.table-columns.status"),
    getValue: (row) =>
      t("forms.type.maintenance-report.status-options." + row.status),
  },
  {
    key: "id",
    header: t("yard-tables.table-columns.transactionNumber"),
    getValue: (row) => row.id,
  },
  //   {
  //     key: "supplier.name",
  //     header: t("yard-tables.table-columns.supplier"),
  //     getValue: (row) => (row.supplier ? row.supplier.name : ""),
  //   },
  {
    key: "reference_id",
    header: t("yard-tables.table-columns.referenceId"),
    getValue: (row) => row.reference_id,
  },
  {
    key: "currency",
    header: t("yard-tables.table-columns.currency"),
    getValue: (row) => row.currency,
  },
  {
    key: "created_at",
    header: t("yard-tables.table-columns.createdAt"),
    getValue: (row) => convertToPST(row.created_at),
  },
];
const ReceiptsView = () => {
  const { t } = useTranslation();

  const [filters, setFilters] = useState({
    status: "pending",
    created_at_start: "",
    created_at_end: "",
    supplier: "",
    location: "",
    reference_id: "",
  });

  const [createModalOpen, setCreateModalOpen] = useState(false);

  const { state, dispatch, setPage } = usePaginatedQuery(
    buildURLWithParams(DEFAULT_URL, filters),
  );

  const handleFilter = (name, value) => {
    const nextFilters = {
      ...filters,
      [name]: value,
    };

    setFilters(nextFilters);
    setPage(buildURLWithParams(DEFAULT_URL, nextFilters));
  };

  const handleDateRangeSelect = ({ values }) => {
    const nextFilters = {
      ...filters,
      ...values,
    };

    setFilters(nextFilters);
    setPage(buildURLWithParams(DEFAULT_URL, nextFilters));
  };

  const navigate = useNavigate();

  return (
    <PageLayout title={"Receipts"} header={t("receipts")}>
      {createModalOpen && (
        <CreateReceipt close={() => setCreateModalOpen(false)} />
      )}
      <div className="search-filters-cont">
        <div className="search-filters">
          <DateRange
            name="created_at"
            value={filters}
            onSelect={handleDateRangeSelect}
          />
          <InputFilter
            placeholder="referenceId"
            value={filters.reference_id}
            onChange={(value) => handleFilter("reference_id", value)}
            name="reference_id"
          />
          <label>
            {t("yard-tables.table-columns.status")}:{" "}
            <select
              name="status"
              value={filters.status}
              onChange={(e) => handleFilter("status", e.target.value)}
              className="text-input-sm"
            >
              <option value="">
                {t("forms.type.maintenance-report.status-options.all")}
              </option>
              <option value="pending">
                {t("forms.type.maintenance-report.status-options.pending")}
              </option>
              <option value="closed">
                {t("forms.type.maintenance-report.status-options.closed")}
              </option>
              <option value="canceled">
                {t("forms.type.maintenance-report.status-options.canceled")}
              </option>
            </select>
          </label>
          <Button
            labelKey="create"
            variant="primary"
            onClick={() => setCreateModalOpen(true)}
          />
        </div>
      </div>
      <TableNavigation state={state} dispatch={dispatch} />
      <DataTable
        columns={receiptsColumns(t)}
        rows={state.data}
        isLoading={state.isLoading}
        onRowClick={(row) => navigate(`/receipts/${row.id}`)}
      />
    </PageLayout>
  );
};

export default ReceiptsView;
